// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.43G6GBOK.js
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

export {
  clamp
};
